import { createTheme } from '@mui/material/styles';
import { CSSProperties } from 'react';

declare module '@mui/material/styles' {
  interface TypographyVariants {
    list_item: CSSProperties & { [key: string]: unknown };
    warning: CSSProperties & { [key: string]: unknown };
  }

  // allow configuration using `createTheme`
  interface TypographyVariantsOptions {
    list_item?: CSSProperties & { [key: string]: unknown };
    warning?: CSSProperties & { [key: string]: unknown };
  }
}

// Update the Typography's variant prop options
declare module '@mui/material/Typography' {
  interface TypographyPropsVariantOverrides {
    list_item: true;
    warning: true;
  }
}

const breakpointValues = {
  xs: 0,
  sm: 600,
  md: 900,
  lg: 1600,
  xl: 1800,
} as const;

const upMd = `@media (min-width:${breakpointValues.md}px)`;
const downSm = `@media (max-width:${breakpointValues.sm - 0.05}px)`;

export const theme = createTheme({
  breakpoints: {
    values: breakpointValues,
  },

  palette: {
    primary: {
      main: '#0A1F5C',
    },
    secondary: {
      main: '#d56636',
    },
  },

  typography: {
    fontFamily: 'Raleway',
    h6: {
      fontFeatureSettings: `'lnum' on`,
      fontSize: '1rem',
      [upMd]: { fontSize: '1.2rem' },
    },
    body1: {
      fontFeatureSettings: `'lnum' on`,
      fontSize: '0.8rem',
      [upMd]: { fontSize: '1.2rem' },
    },
    body2: {
      fontFeatureSettings: `'lnum' on`,
      fontSize: '0.8rem',
    },
    subtitle2: {
      fontFeatureSettings: `'lnum' on`,
      fontSize: '0.8rem',
    },
    subtitle1: {
      fontFeatureSettings: `'lnum' on`,
      fontSize: '0.8rem',
      [upMd]: { fontSize: '1.2rem' },
    },
    list_item: {
      fontFeatureSettings: `'lnum' on`,
      color: 'red',
    },
    warning: {
      fontFeatureSettings: `'lnum' on`,
      color: '282828',
      fontSize: '0.8rem',
      [downSm]: { fontSize: '0.4rem' },
      [upMd]: { fontSize: '1.0rem' },
    },
  },
});
